<template>

    <div class="reactions" :class="reactionsContainerClass" ref="reactionsContainer">
        <div class="inner-container">
            <button
                    v-for="(reaction, index) in reactionsLookup"
                    type="button"
                    class="btn btn-reaction"
                    :class="postType == 'posts' && userReaction === reaction.id ? 'chosen' : '' "
                    :key="reaction.id"
                    :data-reaction-id="reaction.id"
                    @click.prevent="alterReaction(reaction.id, $event)"
                    :rootPostType=" rootPostType "
                    :rootId=" rootId "
            >
                <span class="image-container">
                    <span class="chosen-frame"><span class="shaper"></span></span>
                    <img :src=" reaction.image " :alt="reaction.name">
                    <span class="reaction-title" v-html="reaction.name"></span>
                </span>
                <span class="reaction-count" v-html="getCountFor(reaction.id)"></span>

                <span class="ajax-loader-container">
                    <span class="ajax-loader on-the-left"></span>
                </span>
            </button>
        </div>
        <span class="total-reactions-count" v-html="totalReactionsCount" v-if="canContract"></span>

        <button class="reactions-toggle"
                @click="toggleReactionsOpen()"
                v-if="canContract">
                        <span class="sr-only"
                              v-text="reactionTogglerAllyText">
                        </span>
        </button>
    </div>

</template>

<script>
export default {
    name       : 'Reactions',
    components : [],
}
</script>

<script setup>
import { useStore }                                  from "vuex";
import { computed, onMounted, ref }                  from 'vue';
import { getCsrfCookie, isUserLoggedIn, isUserProf } from '../../Utils';


import axios from 'axios';

let store           = useStore();
let copydeck        = computed( () => store.state.copydeck );
let reactionsLookup = computed( () => store.state.copydeck.reactions );

let props = defineProps( [
    "postType",
    "postId",
    "commentParentId",
    "reactions",

    "rootPostType",
    "rootId",

    "canContract",
] );

let userReaction = computed( () =>
{


    const foundReaction = store.getters.userReactions.find( ur => ur.id_content === props.postId );

    return foundReaction?.id_reaction ?? 0;

} );

let totalReactionsCount = computed( () =>
{

    let total = 0;
    for ( const reactionIds in props.reactions )
    {
        total += props.reactions[ reactionIds ];
    }

    return total;

} );


let rootPostType = computed( () => props.rootPostType );
let rootId       = computed( () => props.rootId );

let reactionsContainer = ref( null );

let reactionsAreOpen        = ref( false );
let reactionTogglerAllyText = computed( () => reactionsAreOpen.value ? 'Fermer les réactions' : 'Ouvrir les réactions' );
let reactionsContainerClass = computed( () => reactionsAreOpen.value ? ' reactions-are-open ' : ' reactions-are-closed' );


function alterReaction ( reactionId, e )
{

    if ( isUserProf() )
    {
        const triggerEvent = new Event( 'openExplanationProfs' );
        window.dispatchEvent( triggerEvent );
        return;
    }

    const clicked = e.target;
    // const reactionId = clicked.dataset.reactionId;

    console.log( 'About to compare the reaction IDs.  userReaction: ' + userReaction.value, '    clicked: ' + reactionId, e );

    if ( userReaction.value === reactionId )
    {
        deleteReaction( reactionId, e );
    } else
    {
        sendReaction( reactionId, e );
    }
}

async function sendReaction ( reactionId, e )
{

    if ( !isUserLoggedIn() )
    {
        const event = new Event( 'openExplanationJeunes' );
        window.dispatchEvent( event );

        console.log( 'User was not logged in. Popping Explanation (jeunes) modal.', AsGlobalSettings );

        return;
    }

    if (!props.postId)
    {
        //the user is trying to react to his own comment in instacomment mode
        return;
    }

    // const btn = e.currentTarget;
    // // const reactionId = parseInt( btn.dataset.reactionId );
    //
    // btn.disabled = true;
    // btn.classList.add( 'ajaxing' );

    const data = {
        'postType'     : props.postType,
        'postId'       : props.postId,
        'reactionId'   : reactionId,
        'userId'       : store.state?.currentUser?.id ?? 0,
        'mode'         : 'add',
        'rootPostType' : props.rootPostType,
        'rootId'       : props.rootId,
    }

    try
    {

        let currentReaction = userReaction.value;


            if (currentReaction != 0)
            {
                store.commit("reactionAdjusted", {
                    id_comment:        props.postId,
                    id_reaction:       currentReaction,
                    id_comment_parent: props.commentParentId,
                    postType:          props.postType,
                    quantity:          -1
                });
            }

            store.commit("reactionAdjusted", {
                id_comment:        props.postId,
                id_reaction:       reactionId,
                id_comment_parent: props.commentParentId,
                postType:          props.postType,
                quantity:          1
            });



        //let token      = getCsrfCookie();
        const response = await axios.post( '/endpoints/reactions',
            data,
            {
                withCredentials : true,
                // headers         : {
                //     'X-CSRF-TOKEN' : token,
                // },
            } );



        console.log( 'sendReaction:success', response );

        //await store.dispatch( "updateRelatedDataInStore" );


    }
    catch (error)
    {

        console.error( '[Reactions.vue:sendReaction] There was an error', error );
        if ( error.response )
        {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            ////console.log('submitLogin', error.response.data);
            ////console.log('submitLogin', error.response.status);
            ////console.log('submitLogin', error.response.headers);

            // this.formErrors = error.response.data.errors;
            // window.scrollTo( {
            //     top      : this.getElementOffset( '.form-section-register' ).top,
            //     left     : 0,
            //     behavior : 'smooth',
            // } );

        } else if ( error.request )
        {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            ////console.log(error.request);
        } else
        {
            // Something happened in setting up the request that triggered an Error
            ////console.log('Error', error.message);
        }
    }


    // btn.disabled = false;
    // btn.classList.remove( 'ajaxing' );
    // btn.disabled = false;


    // store.dispatch( "updateUserReactions", reactionId );
    // store.dispatch( "updateRelatedDataInStore" );
}


async function deleteReaction ( reactionId, e )
{
    const btn = e.currentTarget;
    // const reactionId = parseInt( btn.dataset.reactionId );

    btn.disabled = true;
    btn.classList.add( 'ajaxing' );

    const data = {
        'postType'   : props.postType,
        'postId'     : props.postId,
        'reactionId' : reactionId,
        'userId'     : store.state?.currentUser?.id ?? 0,
        'mode'       : 'delete',
    }

    try
    {

        let token      = getCsrfCookie();
        const response = await axios.post( '/endpoints/reactions',
            data,
            {
                withCredentials : true,
                // headers         : {
                //     'X-CSRF-TOKEN' : token,
                // },
            } );

        // console.log( 'deleteReaction:success', response );
        //
        // await store.dispatch( "updateRelatedDataInStore" );
        store.commit("reactionAdjusted", {id_comment: props.postId, id_reaction: reactionId, id_comment_parent: props.commentParentId, quantity: -1});

    }
    catch (error)
    {

        console.error( '[Reactions.vue:sendReaction] There was an error', error );
        if ( error.response )
        {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            ////console.log('submitLogin', error.response.data);
            ////console.log('submitLogin', error.response.status);
            ////console.log('submitLogin', error.response.headers);

            // this.formErrors = error.response.data.errors;
            // window.scrollTo( {
            //     top      : this.getElementOffset( '.form-section-register' ).top,
            //     left     : 0,
            //     behavior : 'smooth',
            // } );

        } else if ( error.request )
        {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            ////console.log(error.request);
        } else
        {
            // Something happened in setting up the request that triggered an Error
            ////console.log('Error', error.message);
        }
    }


    // btn.disabled = false;
    btn.classList.remove( 'ajaxing' );
    btn.disabled = false;

    // store.dispatch( "updateUserReactions", 0 );
    // store.dispatch( "updateRelatedDataInStore" );
}

function getCountFor ( reactionId )
{
    // console.log( reactionId, props.reactions?.[ reactionId ], props.reactions )
    return props.reactions?.[ reactionId ] ?? 0;

}


function toggleReactionsOpen ()
{

    const parentRow = reactionsContainer.value.parentNode;

    reactionsAreOpen.value = !reactionsAreOpen.value;


    parentRow.classList.remove( 'reactions-are-open', 'reactions-are-closed' );

    parentRow.classList.add( reactionsAreOpen.value ? 'reactions-are-open' : 'reactions-are-closed' )
}


onMounted( () =>
{
    if ( !props.canContract )
    {
        reactionsAreOpen.value = true;
    }
} )

</script>

<style scoped>

</style>
